import { Field, Portal, Select, Text, createListCollection } from '@chakra-ui/react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

interface SelectOption {
  label: string;
  value: string;
}

interface FormSelectProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  options: SelectOption[];
  placeholder?: string;
  width?: string | number;
  required?: boolean;
}

const FormSelect = ({
  name,
  label,
  control,
  errors,
  options,
  placeholder = 'Välj...',
  width = '100%',
  required,
}: FormSelectProps) => {
  const collection = createListCollection({
    items: options,
  });

  const fieldError = errors[name];
  const isInvalid = !!fieldError;

  return (
    <Field.Root invalid={isInvalid} width={width}>
      <Field.Label>
        {label}
        {required && <Text color="red.fg">*</Text>}
      </Field.Label>
      <Controller
        control={control}
        defaultValue=""
        name={name}
        render={({ field }) => (
          <Select.Root
            invalid={isInvalid}
            multiple={false}
            name={field.name}
            value={field.value ? [field.value] : []}
            onValueChange={({ value }) => {
              field.onChange(value[0]);
            }}
            onInteractOutside={() => field.onBlur()}
            collection={collection}
          >
            <Select.HiddenSelect />
            <Select.Control>
              <Select.Trigger>
                <Select.ValueText placeholder={placeholder} />
              </Select.Trigger>
              <Select.IndicatorGroup>
                <Select.Indicator />
              </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
              <Select.Positioner>
                <Select.Content>
                  {collection.items.map(option => (
                    <Select.Item item={option} key={option.value}>
                      {option.label}
                      <Select.ItemIndicator />
                    </Select.Item>
                  ))}
                </Select.Content>
              </Select.Positioner>
            </Portal>
          </Select.Root>
        )}
      />
      {isInvalid && fieldError.message && (
        <Field.ErrorText>
          {typeof fieldError.message === 'string' ? fieldError.message : 'Invalid selection'}
        </Field.ErrorText>
      )}
    </Field.Root>
  );
};

export default FormSelect;
